import React from 'react'

export const QuestionMarkIcon = ({
    iconColor = '#333333',
}: {
    iconColor: string
}) => {
    return (
        <span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
            >
                <path
                    d="M13.5149 10.1934C15.163 8.75083 17.837 8.75083 19.4851 10.1934C21.1346 11.636 21.1346 13.9751 19.4851 15.4177C19.1994 15.6696 18.8799 15.8765 18.5422 16.0398C17.4936 16.5479 16.5014 17.4458 16.5014 18.6111V19.6667M29.1667 16.5C29.1667 18.1634 28.839 19.8105 28.2025 21.3473C27.5659 22.8841 26.6329 24.2805 25.4567 25.4567C24.2805 26.6329 22.8841 27.5659 21.3473 28.2025C19.8105 28.839 18.1634 29.1667 16.5 29.1667C14.8366 29.1667 13.1895 28.839 11.6527 28.2025C10.1159 27.5659 8.71953 26.6329 7.54332 25.4567C6.36711 24.2805 5.43409 22.8841 4.79753 21.3473C4.16097 19.8105 3.83334 18.1634 3.83334 16.5C3.83334 13.1406 5.16786 9.91879 7.54332 7.54332C9.91878 5.16786 13.1406 3.83334 16.5 3.83334C19.8594 3.83334 23.0812 5.16786 25.4567 7.54332C27.8321 9.91879 29.1667 13.1406 29.1667 16.5ZM16.5 23.8889H16.5113V23.9002H16.5V23.8889Z"
                    stroke={iconColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}
